<div class="modal-header border-0 padding-bottom-0">
  <h5 class="modal-title fw-bold px-2 px-lg-3">Configurar cookies</h5>
</div>
<div class="modal-body">
  <div class="alert d-flex column-gap-1" role="alert">
    <svg class="flex-shrink-0" role="img" aria-label="Info:">
      <use xlink:href="#info-fill" />
    </svg>
    <div class="d-flex flex-column row-gap-3">
      <p class="x-small text-bg-light mb-0">
        Las cookies son una tecnología que nos permite conocer cómo usas nuestro sitio. Con esta información, hacemos
        que sea más fácil usar tu cuenta y te mostramos publicidad relacionada a tus intereses.
      </p>
      <a
        class="alert-link text-info x-small fw-normal text-decoration-underline"
        href="./assets/pdf/POLÍTICA%20DE%20COOKIES.pdf"
        target="_blank"
      >
        Conoce más sobre cookies en NM Viajes.
      </a>
    </div>
  </div>
  <div class="d-flex flex-column row-gap-3">
    @for (option of options; track option.configName) {
      <app-toggle-card (switchChanged)="onToggled(option.configName, $event)" [model]="option"></app-toggle-card>
    }
  </div>
</div>
<div class="modal-footer justify-content-start shadow">
  <app-button
    (buttonClick)="onSave()"
    [isFullWidth]="isMobile()"
    [class.w-100]="isMobile()"
    [buttonSize]="isMobile() ? 'sm' : 'md'"
  >
    Guardar
  </app-button>
</div>

<svg xmlns="http://www.w3.org/2000/svg" class="d-none">
  <symbol id="info-fill" viewBox="0 0 16 16">
    <path
      d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16zm.93-9.412-1 4.705c-.07.34.029.533.304.533.194 0 .487-.07.686-.246l-.088.416c-.287.346-.92.598-1.465.598-.703 0-1.002-.422-.808-1.319l.738-3.468c.064-.293.006-.399-.287-.47l-.451-.081.082-.381 2.29-.287zM8 5.5a1 1 0 1 1 0-2 1 1 0 0 1 0 2z"
    />
  </symbol>
</svg>
